import { Dispatch, SetStateAction } from 'react';
import { useMutation } from 'react-query';

import { errorMessage, requestEnterpriseInfoRoute } from '@features/payments';
import axiosInstance from '@server/axiosInstance';

type useRequestEnterpriseInfoProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useRequestEnterpriseInfo = ({
  setErrorText,
}: useRequestEnterpriseInfoProps) => {
  const {
    mutate: requestEnterpriseInfo,
    isLoading: isRequestEnterpriseInfoLoading,
  } = useMutation({
    mutationFn: (variables: {
      name?: string;
      locations?: number;
      contactPreference?: string[];
      phoneNumber?: string;
      email?: string;
      company_name?: string;
    }) =>
      axiosInstance
        .post(requestEnterpriseInfoRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
      }
    },
    onError: () => setErrorText(errorMessage),
  });

  return {
    requestEnterpriseInfo,
    isRequestEnterpriseInfoLoading,
  };
};
